module.exports = __webpack_public_path__ + "static/media/platform1.35171a14.webp";